<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="20231228"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          :auto-init="searchItemAutoInit"
          :custom-search-items="customSearchItems"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button no="button1" type="primary" @click="toPassChargeSync()">{{
              $t('SeaExport.PassAudit')
            }}
            </el-button>
            <el-button no="button2" type="danger" @click="toNotPassChargeSync()">{{
              $t('FinanceManage.fail')
            }}
            </el-button>
          </div>
          <template v-slot:searchAreaHeader>
            <div class="app-main-inner-row  extension-conditions-form" style="padding-bottom: 5px;margin-top: -7px">
              <div class="filters">
                <el-form :inline="true" label-width="60px" label-position="left">
                  <div class="el-form-item-wrapper dense-radio-group">
                    <el-form-item label-width="0" class="dense-radio-group">
                      <el-radio-group v-model="filter.viewType">
                        <el-radio :label="1">{{ $t('SeaExport.ViewReception') }}</el-radio>
                        <el-radio :label="0">{{ $t('SeaExport.ViewSending') }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </template>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="20231228"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <div :class="['fixedBottom']" class="total-wrapper">
            <span v-show="showCount">
              {{ this.$t('SeaExport.Select') + ' ' + selectionCount + ':' }}
            </span>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_ReceivableToCNY') }}</span>
              <span>{{ receivable }}</span>
            </div>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_DuesToCNY') }}</span>
              <span>{{ dues }}</span>
            </div>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_EquivalentCNY') }}</span>
              <span>{{ amountTo }}</span>
            </div>
            <charge-count-group
              :data-provider="selectedRows"
              :data-field="'amount'"
              :display-and-count-field-list="displayAndCountFieldList"
              :always-show="true"
            />
          </div>
          <cargo-pagination
            config-module="990003"
            :total="total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQueryByPage"
          />
        </div>
        <!--拒绝-->
        <reject-dialog
          v-if="rejectWindow.visible"
          :visible.sync="rejectWindow.visible"
          :job-no="rejectWindow.jobNo"
          :reject-call-back="rejectWindow.rejectCallBack"
          :append-to-body="true"
        />
      </div>
    </div>
  </div>
</template>

<script>

import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { branchTransactionsAdvancedSearch } from '@/api/clearing/chargeConfirmed'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { notPassChargeSync, passChargeSync } from '@/api/booking/job'
import $store from '@/store'
import rejectDialog from '@/views/cargo/v0/AirExport/components/verify/rejectDialog.vue'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'

export default {
  name: 'BranchTransactions',
  components: { rejectDialog, searchItem, ChargeCountGroup, ChargeCurrencyTotalGroup },
  data() {
    return {
      loading: false,
      isAdvancedQuery: false, // 记录上一次操作是否为高级查询
      SystemConstants,
      rowData: [],
      selectedRows: [],
      showCount: false,
      gridApi: null,
      total: 0,
      pageCount: 0,
      searchItemAutoInit: true,
      customSearchItems: [], // 自定义高级查询项
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        context: { componentParent: this },
        onSelectionChanged: this.filterChange
      },
      filter: {
        conditions: {},
        viewType: 1,
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        viewType: 1 // 查看接收/发送
      },
      rejectWindow: {
        visible: false,
        jobNo: null,
        rejectCallBack: null
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.receivablePayable'),
          colId: 'receivable',
          field: 'receivable',
          width: 120,
          valueFormatter: params => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.sender'),
          field: 'sender',
          colId: 'sender',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('FinanceManage.receiver'),
          field: 'receiver',
          colId: 'receiver',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'ourJobNo',
          width: 80
        },
        {
          headerName: this.$t('SeaExport.TheirJobNo'),
          field: 'theirJobNo',
          width: 80
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          width: 180,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('FinanceManage.currency'),
          colId: 'currency',
          field: 'currency',
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'),
          colId: 'amount',
          field: 'amount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount',
          field: 'excludingTaxAmount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'),
          colId: 'taxAmount',
          field: 'taxAmount',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'),
          colId: 'taxRate',
          field: 'taxRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          width: 180,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.000000')
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          width: 180,
          valueFormatter: params => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        {
          headerName: this.$t('FinanceManage.syncProgress'),
          colId: 'syncProgress',
          field: 'syncProgress',
          width: 180,
          cellRenderer: params => {
            const text = ColumnUtils.chargeSyncProgrssLabelFunc(params.value)
            if (params.value === ChargeConstants.THE_OTHER_PARTY_HAS_REFUSED.code) {
              return `<span style="color: red">${text}</span>`
            }
            return text
          }
        },
        {
          headerName: this.$t('FinanceManage.processingStatus'),
          colId: 'handlingStatus',
          field: 'handlingStatus',
          width: 180,
          valueFormatter: params => {
            let text = params.value ? this.$t('CargoMsg.Cargo_Handled') : this.$t('FinanceManage.pending')
            if (params.data.syncProgress !== ChargeConstants.TO_BE_CONFIRMED_BY_US.code && params.data.syncProgress !== ChargeConstants.TO_BE_CONFIRMED_BY_OTHER_PARTY.code) {
              text += `（${params.data.read ? this.$t('FinanceManage.alreadyRead') : this.$t('FinanceManage.notRead')}）`
            }
            return text
          }
        },
        {
          headerName: this.$t('SeaExport.firstSendTime'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.UpdateTime'),
          colId: 'dateModified',
          field: 'dateModified',
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.auditOperationTime'),
          colId: 'verifiedTime',
          field: 'verifiedTime',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 180
        },
        {
          headerName: 'SO No.',
          colId: 'soNo',
          field: 'soNo',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Unit'),
          colId: 'measure',
          field: 'measure',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DenialReason'),
          colId: 'rejectReason',
          field: 'rejectReason',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.AuditOperator'),
          field: 'verifiedBy',
          colId: 'verifiedBy',
          width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.source'),
          colId: 'syncSource',
          field: 'syncSource',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.chargeConfirmSourceLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          cellRenderer: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          hide: true,
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          hide: true,
          width: 180
        },
        {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          hide: true,
          width: 180
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          width: 180
        }
      ],
      chargeSyncCheckJobState: null,
      privilege: {
        userChargeRole: false,
        branchChargeRole: false,
        departmentChargeRole: false
      },
      selectionCount: 0,
      receivable: 0.00,
      dues: 0.00,
      amountTo: 0.00,
      displayAndCountFieldList: [
        new ChargeCountField(this.$t('CargoMsg.Cargo_Receivable'),
          'amount', 'currency', 'exchangeRate', ChargeCountManager.DISP_IN_GRID, [
            new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'receivable', ChargeGroupCounter.OPERATOR_EQUAL, true)
          ]),
        new ChargeCountField(this.$t('CargoMsg.Cargo_DuesP'),
          'amount', 'currency', 'exchangeRate', ChargeCountManager.DISP_IN_GRID, [
            new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'receivable', ChargeGroupCounter.OPERATOR_EQUAL, false)
          ]),
        new ChargeCountField(this.$t('CargoMsg.Cargo_AmountTo'),
          'totalAmount', 'currency', 'exchangeRate', ChargeCountManager.DISP_IN_GRID, [
            new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'totalAmount')
          ])
      ]
    }
  },
  async created() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.initSearchItems()
    this.initConfig()
  },
  methods: {
    initConfig() {
      const chargeSyncCheckJobStateTxt = cache.config.get('ChargeSyncCheckJobState')
      const checkJobStates = []
      if (chargeSyncCheckJobStateTxt) {
        const jobStateStrs = chargeSyncCheckJobStateTxt.split(',')
        for (const jobStateStr of jobStateStrs) {
          switch (jobStateStr.trim()) {
            case '0': // 正操作
              checkJobStates.push(0)
              break
            case '1': // 已提交
              checkJobStates.push(1)
              break
            case '2': // 已审核
              checkJobStates.push(2)
              break
            case '11': // 预提交
              checkJobStates.push(11)
              break
          }
        }
      }
      this.chargeSyncCheckJobState = checkJobStates.length > 0 ? checkJobStates : null
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery(this.filterJson.jobNo)
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.jobNo = keyword.trim()
      this.filterJson.conditions = []
      this.doAdvancedQuery()
    },
    // 高级查询
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.jobNo = ''
      }
      this.doAdvancedQuery(data)
    },
    doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.loading = getLoading()
      // 查看接收/发送
      this.filterJson.viewType = this.filter.viewType
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = $store.getters.currentOfficeId
      branchTransactionsAdvancedSearch(this.filterJson).then(res => {
        this.handleQueryData(res)
      }).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 审核通过
    toPassChargeSync() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (!(selectedRows.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (this.chargeSyncCheckJobState) {
        for (const row of selectedRows) {
          if (!this.chargeSyncCheckJobState.includes(row.jobState)) {
            this.$message.warning(this.$t('Message.ChargeSyncJobStateCheckFail'))
            return
          }
        }
      } else {
        for (const row of selectedRows) {
          if (row.jobState !== 0) {
            this.$message.warning(this.$t('FinanceManage.businessHasBeenSubmitted'))
            return
          }
        }
      }
      if (!this.checkConfirmedData()) {
        return
      }
      this.$confirm(this.$t('SeaExport.ConfirmReceiveTheseCharges'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'info'
      }).then(() => {
        const keys = Array.from(selectedRows, p => p.uuid)
        const loading = getLoading4Cxt(this)
        passChargeSync(keys).then(res => {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          // this.init()
          // this.refreshCharge = true
        }).finally(() => {
          if (loading) {
            loading.close()
          }
        })
      }).catch(() => {
      })
    },
    // 审核不通过
    toNotPassChargeSync() {
      if (!this.checkConfirmedData()) {
        return
      }
      this.rejectWindow.rejectCallBack = this.rejectFunc
      this.rejectWindow.visible = true
    },
    rejectFunc(reason) {
      if (!reason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ReasonNotEntered'))
        return false
      }
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = Array.from(selectedRows, p => p.uuid)
      const loading = getLoading4Cxt(this)
      notPassChargeSync(keys, { reason: reason }).then(res => {
        this.$message.success(this.$t('Message.OperationSuccessfully'))
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    initSearchItems() {
      this.searchItemAutoInit = true
      return this.customSearchItems
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.filterChange2()
    },
    checkConfirmedData() {
      const selectedRows = this.gridApi.getSelectedRows()
      const keys = []
      let flag = selectedRows.length > 0
      if (flag) {
        for (const row of selectedRows) {
          if (row.syncProgress !== ChargeConstants.TO_BE_CONFIRMED_BY_US.code) {
            flag = false
            break
          }
          keys.push(row.uuid)
        }
      }
      if (flag) {
        flag = keys.length > 0
      }
      if (!flag) {
        this.$message.warning(this.$t('FinanceManage.selectBeConfirmedChargeByUs'))
      }
      return flag
    },
    filterChange() {
      this.showCount = true
      let selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        selectedRows = this.rowData
        this.showCount = false
      }
      if (selectedRows) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
        for (const row of this.selectedRows) {
          row.totalAmount = row.receivable ? row.amount : -row.amount
        }
        this.selectionCount = selectedRows.length
        const receivableData = selectedRows.filter(item => item.receivable)
        if (receivableData) {
          this.receivable = receivableData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        const duesData = selectedRows.filter(item => !item.receivable)
        if (duesData) {
          this.dues = duesData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        this.amountTo = (this.receivable - this.dues).toFixed(2)
      }
    },
    filterChange2() {
      this.showCount = false
      const selectedRows = this.rowData
      if (selectedRows) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
        for (const row of this.selectedRows) {
          row.totalAmount = row.receivable ? row.amount : -row.amount
        }
        this.selectionCount = selectedRows.length
        const receivableData = selectedRows.filter(item => item.receivable)
        if (receivableData) {
          this.receivable = receivableData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        const duesData = selectedRows.filter(item => !item.receivable)
        if (duesData) {
          this.dues = duesData.reduce((accumulator, currentValue) => accumulator + (currentValue.amount * currentValue.exchangeRate), 0).toFixed(2)
        }
        this.amountTo = (this.receivable - this.dues).toFixed(2)
      }
    }
  }
}
</script>
